// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import FormControl from "@material-ui/core/FormControl";
import { connectForm, Input } from '@mzvonar/modular-redux-form';
import type { ZoneType, Shape as ShapeType, ShapeType as ShapeTypeType } from '../../types';
import Field from '../ui/form/Field';
import Shape from './Shape';

export type Props = $ReadOnly<{
    type: ZoneType,
    shapeType: ShapeTypeType,
    shape: ShapeType,
    zoneId: string,

    submitForm: (e: Event) => void,
    inputChange: (name: string, value: mixed) => void,
    setDrawingShapeType: (type: ShapeTypeType) => void,
    setDrawingShape: (shape: ShapeType) => void,
    disableDrawing: () => void
}>;

function ZoneForm({ type, shapeType, shape, zoneId, submitForm, inputChange, setDrawingShapeType, setDrawingShape, disableDrawing }: Props) {
    return (
        <form onSubmit={submitForm}>
            {zoneId &&
                <Input
                    id="id"
                    name="id"
                    type="hidden"
                    value={zoneId}
                />
            }


            <Input
                id="type"
                name="type"
                type="hidden"
                validate={['required']}
                value={type}
            />

            <Input
                id="name"
                name="name"
                type="text"
                label={<FormattedMessage
                    id="newZoneForm.input.name"
                    defaultMessage="Name"
                />}
                component={Field}
                validate={['required']}
            />

            <Shape
                style={{ backgroundColor: 'pink' }}
                type={shapeType}
                shape={shape}
                name="feature"
                inputChange={inputChange}
                setType={setDrawingShapeType}
                setShape={setDrawingShape}
            />

            <FormControl margin="dense" fullWidth>
                <Box display="flex" justifyContent="flex-end">
                    <Button size="large" color="primary" variant="outlined" onClick={disableDrawing}>
                        <FormattedMessage
                            id="newZoneForm.button.cancel"
                            defaultMessage="Cancel"
                        />
                    </Button>
                    <Box ml={2}>
                        <Button size="large" type="submit" color="primary" variant="contained">
                            {zoneId ?
                                <FormattedMessage
                                    id="newZoneForm.button.update"
                                    defaultMessage="Save"
                                />
                                :
                                <FormattedMessage
                                    id="newZoneForm.button.add"
                                    defaultMessage="Add"
                                />
                            }
                        </Button>
                    </Box>
                </Box>
            </FormControl>
        </form>
    );
}

export default connectForm({
    form: 'zoneForm',
    touchOnChange: false
})(ZoneForm);